import React, {useEffect} from 'react'
import styled from 'styled-components'
import { useForm, ValidationError } from '@formspree/react';
import { MDBRow, MDBCol, MDBBtn } from 'mdb-react-ui-kit'
import { HiClipboardCheck } from 'react-icons/hi'


const ContactForm = () => {
    const [state, handleSubmit] = useForm("xpzblkja");

    useEffect(() => {
        if(state.succeeded) {
            setTimeout(() => {
                state.succeeded = false;
            }, 3000);
        }
    },[state])
    if (state.succeeded) {
        return (
            <Wrapper>
                <MDBRow className="d-flex flex-column align-items-center contact-success">
                    <HiClipboardCheck className="mb-4" />
                    <h2 className="text-center display-4 font-weight-bold">Obrigado!</h2>
                    <h1 className="text-center">Entrarei em contacto o mais brevemente possível.</h1>
                </MDBRow>
            </Wrapper>
            
            );
    }
    return (
        <Wrapper>
                 <form onSubmit={handleSubmit}>
                   {/************************ NOME E EMAIL INPUTS */}
                    <MDBRow >
                        <MDBCol md="12" lg="6">
                            <label htmlFor="nome">Nome</label>
                            <input
                                id="nome"
                                type="nome" 
                                name="nome"
                            />
                            <ValidationError 
                                prefix="Name" 
                                field="nome"
                                errors={state.errors}
                            />
                        </MDBCol>
                        <MDBCol md="12" lg="6">
                            <label htmlFor="email">Email</label>
                            <input
                                id="email"
                                type="email" 
                                name="email"
                            />
                            <ValidationError 
                                prefix="Email" 
                                field="email"
                                errors={state.errors}
                            />
                        </MDBCol>
                    </MDBRow>
                    {/************************ TEXT AREA */}
                    <MDBRow>
                        <MDBCol sm="12">
                            <label htmlFor="assunto">Assunto</label>
                            <input
                                id="assunto"
                                type="assunto" 
                                name="assunto"
                            />
                            <ValidationError 
                                prefix="Subject" 
                                field="assunto"
                                errors={state.errors}
                            />
                        </MDBCol>
                        <MDBCol sm="12">
                            <label htmlFor="mensagem">Mensagem</label>
                            <textarea
                                id="mensagem"
                                name="mensagem"
                            />
                            <ValidationError 
                                prefix="Message" 
                                field="mensagem"
                                errors={state.errors}
                            />
                        </MDBCol> 
                    </MDBRow>
                    {/************************ ENVIAR BUTTON */}
                    <MDBRow>
                        <MDBCol sm="12" className="text-center">
                            <MDBBtn rounded type="submit" disabled={state.submitting} className="main-btn">enviar</MDBBtn>
                        </MDBCol>  
                    </MDBRow>
                </form>
        </Wrapper>
    );
}

const Wrapper = styled.section`

        .contact-success {
            svg {
                font-size: 6rem;
                color: var(--website-main-color);
            }
            h2 {
                color: var(--website-main-color);
            }
            
        }
        
        form input,
        form select,
        form textarea,
        form fieldset,
        form optgroup,
        form label,
        .StripeElement {
            font-family: inherit;
            font-size: 1.2rem;
            color: inherit;
            border: none;
            border-radius: 10px;
            display: block;
            width: 100%;
            padding: 0;
            margin: 0;
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;
        }
        form label,
        form legend {
            font-size: 1.5rem;
            margin-bottom: 0.5rem;
            font-weight: 600;
            color: var(--website-main-color);
        }
        /* border, padding, margin, width */
        form input,
        form select,
        form textarea,
        .StripeElement {
            box-sizing: border-box;
            border: 2px solid var(--website-main-color);
            background-color: rgba(255, 255, 255, 0.9);
            padding: 0.35rem 0.75rem;
            margin-bottom: 1rem;
        }
        form textarea {
            height:300px;
            max-height: 300px;
        }
        form input:focus,
        form select:focus,
        form textarea:focus,
        .StripeElement:focus {
            background-color: white;
            outline-style: solid;
            outline-width: thin;
            outline-color: gray;
            outline-offset: -1px;
        }
        form [type="text"],
        form [type="email"],
        .StripeElement {
            width: 100%;
        }
        form [type="button"],
        form [type="submit"],
        form [type="reset"] {
            width: auto;
        cursor: pointer;
            -webkit-appearance: button;
            -moz-appearance: button;
            appearance: button;
        }
        form [type="button"]:focus,
        form [type="submit"]:focus,
        form [type="reset"]:focus {
            outline: none;
        }

        form select {
        text-transform: none;
        }
      
`

export default ContactForm
